import React from 'react'
import "../resourses/layout.css";

function Footer() {
  return (
    <div className='footer'>Copyright @2023 Gajraj</div>
  )
}

export default Footer